export const SCREENS = {
    sm:"640px",

    md:"768px",

    lg: "1280px",

    xl:"1536px"
  }